//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MtArrowLink from '~/components/other/MtArrowLink'
import Button from "~/components/other/Button"

export default {
  components: {
    MtArrowLink,
    Button
  },
  data() {
    return {
    }
  },
  computed: {
    currentPage () {
      return this.$route.query.pageNum ? Number(this.$route.query.pageNum) : 1
    }
  }
}
